module.exports = __webpack_public_path__ + "static/media/site_name_logo_with_icon.7cb5d323.png";